import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
export const ScrollIntoView = ({ scrollToView , block ='nearest' , behavior ='auto' , children  })=>{
    const ref = useRef(null);
    if (scrollToView) ref.current?.scrollIntoView({
        block,
        behavior
    });
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "ScrollIntoView",
        id: "scrollIntoView",
        ref: ref,
        children: children
    });
};
export default ScrollIntoView;

//# sourceMappingURL=index.js.map